module.exports = __webpack_public_path__ + "static/media/button-dark.3667516c.svg";